import React from 'react';
import { ReactComponent as Logo } from '../icons/logo.svg';

class CustomUI extends React.Component {

    static defaultProps = {
        minLevel: 100,
        maxLevel: 250,
        step: 10,
        compassOrientation: 0
    }

    constructor(props) {
        super(props);

        this.state = {
            currentZoomLevel: 100,
        };
    }

    zoomIn = () => {
        this.zoom(1);
    }

    zoomOut = () => {
        this.zoom(-1);
    }

    resetZoom = () => {
        this.setState({ currentZoomLevel: 100 });
        this.props.onZoomLevelChanged(100);
    }

    zoom = (direction) => {
        let newLevel = this.state.currentZoomLevel + Math.sign(direction) * this.props.step;
        newLevel = Math.max(this.props.minLevel, Math.min(this.props.maxLevel, newLevel));
        if (newLevel === this.state.currentZoomLevel)
            return;
        this.setState({ currentZoomLevel: newLevel });
        this.props.onZoomLevelChanged(newLevel);
    }

    render() {
        const aerialViewButtonClass = `viewButton ${this.props.selectedSet === 0 ? 'activeSet' : ''}`;
        const floorViewButtonClass = `viewButton ${this.props.selectedSet === 1 ? 'activeSet' : ''}`;

        return (
            <div id="UI">
                <svg className="main" viewBox="0 0 872 84">
                    <rect className="background" x="0" y="0" style={{ width: '872px', height: '84px' }} />
                    <g>
                        <text transform="translate(48.769 49.716) scale(1.114 1)">VUES</text>
                        <path className="separator" d="M108.929,69.657l.383-56.214Z" />
                    </g>
                    <g className={aerialViewButtonClass} onClick={() => this.props.onSetSelected(0)}>
                        <circle cx="148.191" cy="41.55" r="22.5" />
                        <path d="M147.955,29.118l-.863,2.3a1.361,1.361,0,0,0-.084.465l0,5.165-9.957,7.824a.747.747,0,0,0-.285.589v.989a.747.747,0,0,0,1.014.7l9.228-3.515V47.3l-3.195,3.2a.75.75,0,0,0-.22.529v.535a.748.748,0,0,0,1.026.7l3.85-1.541,3.851,1.541a.747.747,0,0,0,1.025-.7V51.02a.75.75,0,0,0-.22-.529L149.933,47.3V43.638l9.229,3.516a.748.748,0,0,0,1.015-.7v-.99a.752.752,0,0,0-.286-.588l-9.958-7.823V31.888a1.323,1.323,0,0,0-.084-.465l-.863-2.3a.549.549,0,0,0-1.031,0Zm0,0" />
                    </g>
                    <g className={floorViewButtonClass} onClick={() => this.props.onSetSelected(1)}>
                        <circle cx="213.438" cy="41.55" r="22.5" />
                        <path d="M210.47,43.806l-.77,3.73-2.43,2.9a1.28,1.28,0,0,0,.1,1.78,1.221,1.221,0,0,0,1.723-.091l.017-.019h0l2.64-3.13a1.3,1.3,0,0,0,.28-.59l.3-1.56Zm5.19-5.34-.56,2.39.08.09a7.385,7.385,0,0,0,3.71,1.65.86.86,0,0,0,1-.65.879.879,0,0,0-.62-1.07h0a6.009,6.009,0,0,1-2.9-1.19A3.565,3.565,0,0,1,215.66,38.466Zm-1.79-2.77h-.58a4.7,4.7,0,0,0-2.15.53,6.867,6.867,0,0,0-2.74,2.31,7.86,7.86,0,0,0-.7,4.08.871.871,0,0,0,.85.89h0a.86.86,0,0,0,.87-.85v-.02h0a6.4,6.4,0,0,1,.46-3.1,4.815,4.815,0,0,1,1.78-1.53l-.79,3.88-.07.32a1.624,1.624,0,0,0,.24,1.3l1.49,2.38.43.65,3.42,5.44a1.211,1.211,0,0,0,1.659.419l.031-.019a1.28,1.28,0,0,0,.39-1.74h0l-4.59-7.3.4-1.8.31-1.31.64-2.74a1.43,1.43,0,0,0-1.085-1.707,1.392,1.392,0,0,0-.265-.033Zm.37,0,.32-5.16a2.25,2.25,0,1,0,2.2,2.3v-.049a2.22,2.22,0,0,0-2.19-2.25Z" />
                    </g>
                    <g>
                        <circle cx="436" cy="42" r="40" fill="#333649" />
                        <circle cx="436" cy="42" r="33.7" fill="#eaebed" />
                        <g transform={`rotate(${-this.props.compassOrientation} 436 42)`}>
                            <g>
                                <line stroke="#333649" x1="436" y1="66" x2="436" y2="72" />
                                <line stroke="#333649" x1="406" y1="42" x2="412" y2="42" />
                                <line stroke="#333649" x1="460" y1="42" x2="466" y2="42" />
                            </g>
                            <g transform={`rotate(-45 436 42) translate(-1.5 0)`}>
                                <polygon fill="#f00" points="449.952 29.3 433.292 39.8 439.112 45.62 449.952 29.3" />
                                <polygon fill="#333649" points="422.462 56.8 432.952 40.14 438.772 45.96 422.462 56.8" />
                                <path fill="#333649" d="M446.462,26.46l.36.36c.51.51.9.63,1.17.35l5.15-5.14-1.8,8.62a1.318,1.318,0,0,0,.5,1.19l.48.48q.765.765,1.17.36l8.15-8.15c.26-.26.15-.66-.35-1.17l-.38-.37c-.51-.51-.91-.62-1.17-.36l-5.1,5.1,1.82-8.51a1.352,1.352,0,0,0-.5-1.18l-.54-.54c-.52-.52-.92-.63-1.18-.37l-8.15,8.14C445.822,25.55,445.942,25.94,446.462,26.46Z" />
                            </g>
                        </g>
                    </g>
                    <g>
                        <text transform="translate(640 49.716) scale(1.114 1)">Zoom</text>
                        <path className="separator" d="M704.929,69.657l.383-56.214Z" />
                    </g>
                    <g>
                        <rect className="white" x="726.938" y="23.55" rx="17" style={{ width: '104px', height: '36px' }} />
                        <g className="button" onClick={this.zoomOut}>
                            <circle className="blue" cx="747.938" cy="41.55" r="10" />
                            <rect className="white" x="744.5" y="40.215" style={{ width: '7.19px', height: '2.67px' }} />
                        </g>
                        <g className="button" onClick={this.resetZoom}>
                            <circle className="white" cx="778.5" cy="41.55" r="11" />
                            <path className="blue" d="M771.6,49.785a1.288,1.288,0,0,0,.9-.37l3.54-3.5a6.233,6.233,0,0,0,3.79,1.3,6.95,6.95,0,1,0-6.95-6.95,6.24,6.24,0,0,0,1.3,3.8l-3.49,3.54a1.255,1.255,0,0,0-.38.9A1.291,1.291,0,0,0,771.6,49.785Zm8.23-5.25a4.265,4.265,0,1,1,4.27-4.27A4.266,4.266,0,0,1,779.828,44.535Z" />
                        </g>
                        <g className="button" onClick={this.zoomIn}>
                            <circle className="blue" cx="810.938" cy="41.55" r="10" />
                            <polygon className="white" points="806.388 40.17 806.388 42.92 809.188 42.92 809.188 45.74 811.858 45.74 811.858 42.92 814.658 42.92 814.658 40.17 811.858 40.17 811.858 37.36 809.188 37.36 809.188 40.17 806.388 40.17" />
                        </g>
                    </g>
                </svg>
                <p>Illustration non contractuelle</p>
                <Logo className="logo" />
            </div>
        );
    }
}

export default CustomUI;